var _mask, _rect, _path, _mask2, _rect2, _mask3, _rect3, _line, _line2, _line3, _circle, _mask4, _path2, _line4, _line5, _line6, _line7, _line8, _line9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustomReport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 27,
    viewBox: "0 0 25 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_1995_5684",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 2,
    width: 23,
    height: 17,
    rx: 0.5
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 2,
    width: 23,
    height: 17,
    rx: 0.5,
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    mask: "url(#path-1-inside-1_1995_5684)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 5.5H15L14 7",
    stroke: "black"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_1995_5684",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    width: 5,
    height: 3,
    rx: 0.2
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    width: 5,
    height: 3,
    rx: 0.2,
    fill: "#D9D9D9",
    stroke: "black",
    strokeWidth: 2,
    mask: "url(#path-3-inside-2_1995_5684)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-3_1995_5684",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 18,
    width: 25,
    height: 3,
    rx: 0.5
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 18,
    width: 25,
    height: 3,
    rx: 0.5,
    fill: "#D9D9D9",
    stroke: "black",
    strokeWidth: 2,
    mask: "url(#path-4-inside-3_1995_5684)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 6.57125,
    y1: 25.7428,
    x2: 9.57125,
    y2: 20.7428,
    stroke: "black"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 12.5,
    y1: 21,
    x2: 12.5,
    y2: 27,
    stroke: "black"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 15.4287,
    y1: 20.7428,
    x2: 18.4287,
    y2: 25.7428,
    stroke: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 10,
    r: 4.5,
    fill: "#D9D9D9",
    stroke: "black"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-9-inside-4_1995_5684",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 10C14 10.9889 13.7068 11.9556 13.1573 12.7779C12.6079 13.6001 11.827 14.241 10.9134 14.6194C9.99979 14.9978 8.99445 15.0969 8.02455 14.9039C7.05464 14.711 6.16373 14.2348 5.46447 13.5355C4.7652 12.8363 4.289 11.9454 4.09607 10.9755C3.90315 10.0055 4.00216 9.00021 4.3806 8.08658C4.75904 7.17295 5.3999 6.39206 6.22215 5.84265C7.04439 5.29324 8.01109 5 9 5L9 10H14Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 10C14 10.9889 13.7068 11.9556 13.1573 12.7779C12.6079 13.6001 11.827 14.241 10.9134 14.6194C9.99979 14.9978 8.99445 15.0969 8.02455 14.9039C7.05464 14.711 6.16373 14.2348 5.46447 13.5355C4.7652 12.8363 4.289 11.9454 4.09607 10.9755C3.90315 10.0055 4.00216 9.00021 4.3806 8.08658C4.75904 7.17295 5.3999 6.39206 6.22215 5.84265C7.04439 5.29324 8.01109 5 9 5L9 10H14Z",
    fill: "#0869FB",
    fillOpacity: 0.4,
    stroke: "black",
    strokeWidth: 2,
    mask: "url(#path-9-inside-4_1995_5684)"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 5.5,
    x2: 20,
    y2: 5.5,
    stroke: "black"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 7.5,
    x2: 21,
    y2: 7.5,
    stroke: "black"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 9.5,
    x2: 21,
    y2: 9.5,
    stroke: "black"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 11.5,
    x2: 21,
    y2: 11.5,
    stroke: "black"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 13.5,
    x2: 22,
    y2: 13.5,
    stroke: "black"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 15.5,
    x2: 22,
    y2: 15.5,
    stroke: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomReport);
export default __webpack_public_path__ + "static/media/custom_report.e686551bbd209c1d9aa78684ab78d6b9.svg";
export { ForwardRef as ReactComponent };